export default class AvailableDateRange {
	since: Date;

	until: Date;

	constructor(since: Date, until: Date) {
		this.since = since;
		this.until = until;
	}
}
